export const getCenterCoordinates = () => {
  const center: any = {
    lat: 36.44065983,
    lng: 140.0121704
  }
  return center
}
